/**
 * ArchiveScoutReportDialog public entry point.
 * Re-exports the container to provide a stable import path.
 * @module features/reports/components/ArchiveScoutReportDialog
 */
export { default } from "./ArchiveScoutReportDialogContainer";
